import React, { useState } from 'react'
import { Link, Outlet } from "react-router-dom";
import '../css/header.scss'

export default function Header() {

  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <>
      <section className='header'>
        <div className='container'>

          <nav className='header-content'>

            <Link to='/'>
              <div className='logo'></div>
            </Link>

            {/* BOTON HAMBURGUESA */}
            <button
              className='menu-toggle'
              onClick={() => setMenuOpen(!menuOpen)} >
              <i className="fi fi-rr-menu-burger"></i>
            </button>

            {/*<ul>
              <li>Item</li>
              <li>Item</li>
              <li>Item</li>
            </ul>*/}

            {/* MENU */}
            <ul className={`item-list ${menuOpen ? 'active' : ''}`}>
              <li>
                <a
                  href='https://facturacion.bajaferries.com/'
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facturación
                  <i className="fi fi-rs-arrow-up-right-from-square"></i>
                </a>
              </li>

              {/*<li>
                Es
                <i className="fi fi-rr-angle-small-down"></i>
              </li>*/}
            </ul>

          </nav>

        </div>
      </section>

      <Outlet />
    </>
  )
}